var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:"spinner",staticClass:"mdui-spinner",class:{ 'mdui-spinner-colorful': _vm.colorful }})
}
var staticRenderFns = []

export { render, staticRenderFns }